import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const initialState = {
  phone: localStorage.getItem("phone") || null,
  token: localStorage.getItem("token") || null,
  customer_id: localStorage.getItem("customer_id") || null,
  isAuthenticated: !!localStorage.getItem("token"),
  customer_data: JSON.parse(localStorage.getItem("customer_data")) || {},
  isSecondaryUser: localStorage.getItem("isSecondaryUser") === "true" || false,
  secondaryUserInfo: JSON.parse(localStorage.getItem("secondaryUserInfo")) || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials(state, action) {
      const { phone, token , isSecondaryUser, secondaryUserInfo } = action.payload;

      if (phone !== undefined) {
        state.phone = phone;
        localStorage.setItem("phone", phone);
      }

      if (token !== undefined) {
        state.token = token;
        if (token) {
          localStorage.setItem("token", token);

          // ✅ Decode the token
          try {
            const decoded = jwtDecode(token);

            // extract customer_id
            const cid = decoded?.data?.customer_data?._id || decoded?.data?.customer_data?.id || null;
            if (cid) {
              state.customer_id = cid;
              localStorage.setItem("customer_id", cid);
            }

            // extract customer_data
            const cdata = decoded?.data?.customer_data || {};
            state.customer_data = cdata;
            localStorage.setItem("customer_data", JSON.stringify(cdata));
            
           // Check if secondary user from token
            const isSecUser = cdata?.isSecondaryUser || false;
            const secUserInfo = cdata?.secondaryUserInfo || null;
            
            if (isSecUser && secUserInfo) {
              state.isSecondaryUser = true;
              state.secondaryUserInfo = secUserInfo;
              // Also update phone to secondary user's phone
              if (secUserInfo.phone) {
                state.phone = secUserInfo.phone;
                localStorage.setItem("phone", secUserInfo.phone);
              }
              localStorage.setItem("isSecondaryUser", "true");
              localStorage.setItem("secondaryUserInfo", JSON.stringify(secUserInfo));
            }

          } catch (e) {
            console.error("Invalid token, cannot decode:", e);
          }
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("customer_id");
          localStorage.removeItem("customer_data");
          localStorage.removeItem("isSecondaryUser"); //new
          localStorage.removeItem("secondaryUserInfo");  //new
          state.customer_id = null;
          state.customer_data = {};
          state.isSecondaryUser = false; //new
          state.secondaryUserInfo = null; //new
        }
      }
       // Handle secondary user info from action payload (for login response)=> new
      if (isSecondaryUser !== undefined) {
        state.isSecondaryUser = isSecondaryUser;
        if (isSecondaryUser && secondaryUserInfo) {
          localStorage.setItem("isSecondaryUser", "true");
          localStorage.setItem("secondaryUserInfo", JSON.stringify(secondaryUserInfo));
          if (secondaryUserInfo.phone) {
            state.phone = secondaryUserInfo.phone;
            localStorage.setItem("phone", secondaryUserInfo.phone);
          }
        } else {
          localStorage.removeItem("isSecondaryUser");
          localStorage.removeItem("secondaryUserInfo");
        }
      }


      state.isAuthenticated = !!state.token;
    },
    clearCredentials(state) {
      state.phone = null;
      state.token = null;
      state.customer_id = null;
      state.customer_data = {};
      state.isAuthenticated = false;
      state.isSecondaryUser = false; //new
      state.secondaryUserInfo = null; //new
      localStorage.removeItem("phone");
      localStorage.removeItem("token");
      localStorage.removeItem("customer_id");
      localStorage.removeItem("customer_data");
      localStorage.removeItem("isSecondaryUser"); //new
      localStorage.removeItem("secondaryUserInfo"); //new
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export default authSlice.reducer;
